module.exports = __webpack_public_path__ + "img/laundry.9535663.svg";